<zc-timeline-caption>
  <ng-content></ng-content>
</zc-timeline-caption>
